require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-embracing-innovation.json") })
        }
      }, "path---articles-tags-embracing-innovation");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-embracing-innovation!./.cache/json/articles-tags-embracing-innovation.json
// module id = 1783
// module chunks = 231608221292675